import { Folder, SaveResponse, Scalars } from '@core/types';
import gql from 'graphql-tag';
import { Maybe } from 'graphql/jsutils/Maybe';

/************************************************************************
 *  FIND USER FOLDERS
 ************************************************************************/

export interface IUserFoldersResponse {
    findAllUserFolders: Maybe<Array<Folder>>;
}

export const GET_ALL_USER_FOLDERS = gql`
    query {
        findAllUserFolders {
            id
            name
            parent
            description
            reports {
                id
                name
                shared
            }
            schedules {
                id
                name
            }
        }
    }
`;

/************************************************************************
 *  CREATE/UPDATE USER FOLDERS
 ************************************************************************/

export interface ISaveFolderResponse {
    saveFolder: SaveResponse;
}

export const SAVE_FOLDER = gql`
    mutation saveFolder($saveFolderCriteria: SaveFolderInput!) {
        saveFolder(saveFolderCriteria: $saveFolderCriteria) {
            id
            name
        }
    }
`;

/************************************************************************
 *  DELETE USER FOLDERS
 ************************************************************************/
export interface IDeleteFolderResponse {
    deleteFolder: Scalars;
}

export const DELETE_FOLDER = gql`
    mutation deleteFolder($folderId: Int!) {
        deleteFolder(folderId: $folderId)
    }
`;

/************************************************************************
 *  SET REPORT IN A FOLDER
 ************************************************************************/

export interface ISetFolderResponse {
    setReportFolder: Scalars['Boolean'];
}

export const SET_REPORT_FOLDER = gql`
    mutation setReportFolder($reportFolderInput: SetReportFolderInput!) {
        setReportFolder(reportFolderInput: $reportFolderInput)
    }
`;

/************************************************************************
 *  SET SCHEDULE IN A FOLDER
 ************************************************************************/

export interface ISetFolderResponse {
    setScheduleFolder: Scalars['Boolean'];
}

export const SET_SCHEDULE_FOLDER = gql`
    mutation setScheduleFolder($scheduleFolderInput: SetScheduleFolderInput!) {
        setScheduleFolder(scheduleFolderInput: $scheduleFolderInput)
    }
`;
